import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class GoPeriodService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/GoPeriods`);
    }
}